{
  "FRONTEND": {
    "SALES_UI": {
      "OPPORTUNITY_ATTACHMENT": {
        "ADD_ATTACHMENT": "Add attachment",
        "FILE": "file",
        "ATTACHMENT_ADDING_ERROR": "There was an error adding the attachment to the opportunity. Please try again",
        "ATTACHMENT_UPLOAD_ERROR": "Something went wrong uploading the attachment",
        "ATTACHMENT_UPLOAD_SUCCESS": "Successfully added attachment",
        "ATTACHMENTS": "Attachments",
        "NO_ATTACHMENTS_MESSAGE": "There are no attachments for this opportunity."
      },
      "SALES_OPPORTUNITIES": {
        "REOPENING_OPPORTUNITIES": {
          "MUST_ENTER_REASON_ON_REOPEN": "You must enter a reason for reopening this opportunity.",
          "REOPEN_OPPORTUNITY_ACTION": "Reopen opportunity ({{ opportunityName }})",
          "OPPORTUNITY_REOPEN_DETAILS": "This will reopen the opportunity and allow you to edit its details.",
          "OPPORTUNITY_REOPEN_REASON": "Reason for reopening opportunity",
          "CANNOT_REOPEN_OPPORTUNITY": "Unable to reopen opportunity. Please try again."
        },
        "OPPORTUNITY_VALUE": "Opportunity value",
        "REOPEN": "Reopen",
        "ADD_PACKAGES": "Add packages",
        "OPPORTUNITIES_LABEL": "Opportunities",
        "SUCCESSFUL_CREATION": "Successfully created opportunity",
        "OPPORTUNITY_CREATE": "Create sales opportunity",
        "OPPORTUNITY_NAME": "Opportunity name",
        "EMPTY_OPPORTUNITIES_DESCRIPTION": "There are no opportunities.",
        "POTENTIAL_REVENUE": "Potential revenue",
        "PROJECTED_MONTHLY_REVENUE": "Monthly revenue",
        "MONTHLY_REVENUE": "Monthly revenue",
        "PROBABILITY_TO_CLOSE": "{{percentage}}% probability.",
        "NO_ASSIGNEE_TEXT": "Salesperson deleted",
        "NO_PACKAGES_TIP": "Create sales opportunities using the packages in your store. Come back to begin tracking your opportunities as packages become available.",
        "PROBABILITY_OF_CLOSE": "Probability of close",
        "PIPELINE_STAGE": "Pipeline stage",
        "EXPECTED_CLOSE_PLACEHOLDER": "Expected close date",
        "SELECT_PACKAGES": "Select packages *",
        "SELECT_A_PACKAGE_ERROR": "At least one package must be selected",
        "SELECT_QUANTITIES": "Select package quantities",
        "NO_NOTES_FOR_OPPORTUNITY": "There are no notes for this opportunity.",
        "NO_PACKAGES_FOR_OPPORTUNITY": "There are no packages for this opportunity.",
        "REMOVE_PACKAGE_CONFIRMATION": "Are you sure you want to remove {{ packageName }}?",
        "PACKAGE_WILL_BE_REMOVED": "The package will be removed from this opportunity.",
        "REVENUE_TOOLTIP": "This adds up all one-time fees and calculates all recurring revenue for the contract length. To change this value, edit the revenue for the packages below.",
        "QUANTITIES": "Quantities",
        "QUANTITY": "Quantity",
        "DETAILS": "Details",
        "ACTIVITY": "Activity",
        "ASSIGNED_TO": "Assigned to {{ person }}",
        "ASSIGN_TO": "Assign to",
        "SUBSCRIBERS": "Subscribers",
        "OVERVIEW": "Overview",
        "BUSINESS": "Business:",
        "CONTRACT_DURATION_REVENUE": "{{ durationAndPeriod }} revenue",
        "DEFAULT_DURATION_REVENUE": "Per year",
        "ADD_OPPORTUNITY_TAGS": "Add opportunity tags",
        "CLOSED_WON": "Closed won",
        "CLOSED_LOST": "Closed lost",
        "WON": "Won",
        "LOST": "Lost",
        "OPEN": "Open",
        "WON_FILTER": "closed-won",
        "LOST_FILTER": "closed-lost",
        "OPEN_FILTER": "open",
        "STAGE": "Stage",
        "ACTUAL_CLOSE_DATE_UPDATED": "Actual close date updated",
        "OPPS_NOT_ON_PIPELINE": "Migrate opportunities",
        "HIDE_ORPHANED_OPPORTUNITIES": "Show pipeline",
        "SUCCESSFULLY_ASSIGNED_OPPORTUNITIES": "Successfully assigned all selected opportunities",
        "FAILED_TO_ASSIGNED_OPPORTUNITIES": "Failed to assign one or more opportunities, please try again",
        "OPPORTUNITY_ITEMS_REQUIRED": "You must add at least one item to the opportunity contents",
        "ACCOUNT_REQUIRED": "You must select an account for the opportunity",
        "OPPORTUNITY_CONTENTS": "Items",
        "CLOSE": {
          "CLOSE_OPPORTUNITY": "Close opportunity",
          "TITLE": "Close opportunity",
          "CLOSE_STATE": "Close state",
          "MESSAGE": "This will close the opportunity with the current revenue and packages. The opportunity will no longer be editable.",
          "OPPORTUNITY_CLOSE": "Close opportunity",
          "SELECT_STATE": "Select state",
          "CLOSED_LOST": {
            "REASON": "Reason",
            "SELECT_REASON": "Select reason",
            "PRICE": "Price",
            "NO_BUDGET": "No budget",
            "LOST_TO_COMPETITOR": "Lost to competitor",
            "NOT_READY": "Not ready",
            "OTHER": "Other"
          }
        },
        "OPPORTUNITY_INFO": "Opportunity info",
        "ACCOUNT_INFO": "Account info",
        "ITEMS": "Items",
        "ERRORS": {
          "BAD_DATE_ERROR": "Date cannot be before today",
          "INCORRECT_DATE_FORMAT": "Date must be in the form of MM/DD/YYYY",
          "EXCEED_SUBSCRIBERS_LIMIT": "Subscribers must be less than or equal to 5",
          "INVALID_ASSIGNEE_AND_SUBSCRIBERS": "Account assignee cannot be a subscriber to an opportunity",
          "GENERIC_ERROR": "An error occurred",
          "PIPELINE_STAGE_SELECTION": "Select a pipeline stage",
          "UPDATE_OPPORTUNITY": "Failed to update opportunity. Make sure the opportunity has all required information and try again."
        },
        "ADD_SUBSCRIBER_PLACEHOLDER": "Add subscribers",
        "SUBSCRIBERS_UPDATED": "Subscribers updated",
        "SUBSCRIBERS_UPDATE_ERROR": "Failed to update opportunity subscribers",
        "NAME_UPDATED": "Opportunity name updated",
        "NAME_UPDATE_ERROR": "Failed to update opportunity name",
        "ADD_TAG_PLACEHOLDER": "Add tag",
        "LOG_ACTIVITY": "Log activity",
        "EDIT_BILLING_TERMS": "Edit billing terms",
        "ADD_BILLING_TERMS": "Add billing terms",
        "REMOVE_ITEM": "Remove item"
      },
      "OPPORTUNITY_DETAILS": {
        "CREATE_ORDER": "Create order"
      },
      "ACCOUNT_DETAILS": {
        "TITLE": "General info",
        "BUSINESS_CATEGORY_LABEL": "Business category",
        "SERVICE_CATEGORY_LABEL": "Service categories",
        "TAGS_LABEL": "Tags",
        "EDIT_ACCOUNT_INFO": "Edit account info",
        "BREADCRUMBS": {
          "PREVIOUS_PAGE": "Previous page"
        },
        "LOCAL_TIME": {
          "TITLE": "Local time",
          "ADD_TIMEZONE": "Add timezone"
        }
      },
      "OPPORTUNITY_TAGS": {
        "TITLE": "Tags",
        "EMPTY_STATE": {
          "DESCRIPTION": "There are no tags for this opportunity.",
          "ACTION": "Add tags"
        },
        "ADD_DIALOG": {
          "TITLE": "Add opportunity tags",
          "LABEL": "Add tag"
        }
      },
      "VIEW_ALL": "View all",
      "ORDERS": "Orders",
      "PACKAGES": "Packages",
      "PACKAGE": "Package",
      "PRODUCTS": "Products",
      "PRODUCT": "Product",
      "ADDONS": "Add-ons",
      "ADDON": "Add-on",
      "ITEMS": "Items",
      "ITEM": "Item",
      "ATTACHMENTS": "Attachments",
      "CUSTOMER_AGREEMENTS": "Customer agreements",
      "LAST_ACCEPTED": "Accepted on",
      "ADMIN": "Admin",
      "ORDER_ID": "Order ID",
      "ACCOUNT": "Account",
      "ORDER_FILTERS": "Order filters",
      "TOTAL_ORDERS": "Total orders",
      "PENDING_APPROVAL": "Pending approval",
      "STATUS": "Status",
      "PENDING": "Pending",
      "RESUBMITTED": "Resubmitted",
      "AWAITING_CUSTOMER_APPROVAL": "Awaiting customer approval",
      "APPROVED": "Approved",
      "PROCESSING": "Processing",
      "ACTIVATION_ERRORS": "Activation errors",
      "ARCHIVED": "Archived",
      "ACTIVATED": "Activated",
      "FULFILLED": "Activated",
      "DECLINED": "Declined",
      "DRAFTED": "Drafted",
      "SCHEDULED_ACTIVATION": "Scheduled activation",
      "CANCELLATION_REQUESTED": "Cancellation requested",
      "CANCELLATION_DECLINED": "Cancellation declined",
      "CANCELLED": "Cancelled",
      "AWAITING_PAYMENT": "Awaiting payment",
      "PROCESSING_PAYMENT": "Processing payment",
      "PRODUCT_ACTIVATION_INITIATED": "Product activation initiated",
      "TAG": "Tag",
      "TAGS": "Tags",
      "ADD_TAG": "Add tag",
      "INCLUDED_TAG": "Included tag",
      "UNTAGGED": "Untagged",
      "NO_TAGS_FOUND": "No tags found",
      "NO_TAGS": "No tags",
      "TAGS_ERROR": "Error updating tags",
      "MAX_TAGS": "Cannot submit more than {{maxTags}} tags",
      "SUBMITTED": "Submitted",
      "SUBMITTED_FOR_ADMIN_APPROVAL": "Submitted for admin approval",
      "SUBMITTED_FOR_CUSTOMER_APPROVAL": "Submitted for customer approval",
      "CONTRACT_START": "Contract start",
      "CONTRACT_START_DATE": "Contract start {{startDate}}",
      "CONTRACT_START_HINT": "Scheduled contracts will be automatically activated at 7 AM local time",
      "CONTRACT_START_FORMAT": "Contract start date",
      "CONTRACT_START_ERROR": "We couldn't update the contract start date. Refresh the page to try again.",
      "UPDATED_TAGS": "Updated tags",
      "UPDATED_NOTES": "Updated admin notes",
      "UPDATED_SALESPERSON": "Updated the salesperson",
      "UPDATED_CUSTOMER_NOTES": "Updated customer notes",
      "UPDATED_CONTRACT_START": "Updated contract start",
      "UPDATED_CONTRACT_LENGTH": "Updated contract length",
      "UPDATED_DRAFT": "Updated draft",
      "UPDATED_PRICING": "Updated pricing",
      "UPDATED_CONTENTS": "Updated contents",
      "UPDATE_ORDER_FORM_ANSWERS": "Update order form answers",
      "ORDER_FORM_ANSWERS_UPDATED": "The order form answers were updated",
      "CONTENTS_UPDATED": "Contents updated",
      "OFFER_EXPIRY": "Offer expiry",
      "FROM": "From",
      "TO": "To",
      "CLIENT": "Client",
      "SALESPERSON": "Salesperson",
      "SALES_TEAM": "Sales team",
      "BUSINESS": "Business",
      "ERROR_LOADING_SALESPEOPLE": "Something went wrong when loading your salespeople. Refreshing the page might help.",
      "MARKET": "Market",
      "ERROR_LOADING_MARKETS": "Something went wrong. You might want to try refreshing the page.",
      "ERROR_LOADING_SALES_TEAMS": "Something went wrong when loading your sales teams. Refreshing the page might help.",
      "EXPIRY": "Expiry",
      "EXPIRED": "Expired",
      "ALREADY_ACTIVATED_TOOLTIP": "This product is already active on this account.",
      "IGNORE_ERRORS": "Ignore errors",
      "ERRORS_IGNORED": "Errors ignored",
      "PENDING_ACTIVATION": "Pending activation",
      "ACTIVATION_WARNINGS": "Activation warnings",
      "MESSAGE": "Enter more information for the salesperson",
      "CONTRACT_LENGTH": "Contract length",
      "NO_CONTRACT_LENGTH": "No contract length",
      "NO_ORDERS": "There are no orders",
      "ORDER_FORM_LABEL": "Order form",
      "ERROR_RETRIEVING_ORDERS": "We couldn't retrieve your orders. Refresh the page to try again.",
      "SHOW_MORE": "Show more",
      "CONTRACT_LENGTH_ERROR": "Error updating the contract length",
      "LENGTH": "Length",
      "PERIOD": "Period",
      "NUMBER_HIGHER_THAN": "Must be a valid number higher than {{minNumber}}",
      "DURATION_WARNING": "Use this field for reference only. Orders and product expiration dates will not be impacted by this timeframe.",
      "REMOVE": "Remove",
      "SAVE": "Save",
      "SELECT": "Select",
      "CANCEL": "Cancel",
      "DECLINE": "Decline order",
      "REASON_FOR_DECLINE": "Reason for decline",
      "DECLINE_MESSAGE_VALIDATION": "Enter a decline message",
      "DECLINE_REASON_VALIDATION": "Select a decline reason",
      "DAYS_PLURAL_OR_SINGULAR": "{{duration}} days",
      "WEEKS_PLURAL_OR_SINGULAR": "{{duration}} weeks",
      "MONTHS_PLURAL_OR_SINGULAR": "{{duration}} months",
      "YEARS_PLURAL_OR_SINGULAR": "{{duration}} years",
      "DAYS_PLURAL_OR_SINGULAR_LABEL": "Days",
      "WEEKS_PLURAL_OR_SINGULAR_LABEL": "Weeks",
      "MONTHS_PLURAL_OR_SINGULAR_LABEL": "Months",
      "YEARS_PLURAL_OR_SINGULAR_LABEL": "Years",
      "NOTES": "Admin notes",
      "NOTES_HINT": "Only admins and salespeople can see these.",
      "NOTES_ERROR": "The admin notes couldn't be saved.",
      "CUSTOMER_NOTES": "Customer notes",
      "CUSTOMER_NOTES_HINT": "These notes will be visible to the customer",
      "CUSTOMER_NOTES_ERROR": "The customer notes couldn't be saved",
      "EDITION": "Edition",
      "CHANGES_EDITION_FROM": "(Changes edition from {{previousEditionName}})",
      "QUANTITY": "Quantity",
      "QUANTITY_ERROR": "You'll need to add a quantity to continue",
      "QUANTITY_DISABLED": "You can only activate one of these at a time",
      "REVENUE": "Revenue",
      "NAME": "Name",
      "BILL_FOR_RECURRING_CHARGES": "Bill for recurring charges",
      "RETAIL_PRICE": "Retail price",
      "WHOLESALE_COST": "Wholesale cost",
      "ADD_ITEMS": "Add items",
      "ARCHIVE": "Archive",
      "SEARCH": "Search",
      "DUPLICATE": "Duplicate order",
      "CHANGE_SALESPERSON": "Change salesperson",
      "EDIT_CUSTOM_FIELDS": "Edit custom fields",
      "SELECT_SALESPERSON": "Select Salesperson",
      "MAX_ONE_SALESPERSON": "Max one. Leave blank to unselect.",
      "ORDER_PERMISSION_ERROR": "You do not have permission to view this order",
      "FULFILLMENT_BANNER_TEXT": "Fulfillment information is required.",
      "FULFILLMENT_BANNER_BUTTON": "View",
      "FULFILLMENT": "Fulfillment",
      "FULFILLMENT_STATUS_UNSET": "Status unset",
      "FULFILLMENT_STATUS_DETAILS_NEEDED": "Details needed",
      "FULFILLMENT_STATUS_IN_REVIEW": "Vendor review",
      "FULFILLMENT_STATUS_IN_PROGRESS": "In progress",
      "FULFILLMENT_STATUS_COMPLETED": "Completed",
      "FULFILLMENT_STATUS_CANCELLED": "Cancelled",
      "TABLE_PRESETS": {
        "UPCOMING_EXPIRATION": "Upcoming expirations",
        "UPCOMING_EXPIRATION_DESC": "Orders with upcoming expirations in next 3 months"
      },
      "ORDER_DETAILS": {
        "TITLE": "Order details",
        "OFFER_WILL_EXPIRE": "This offer expires on {{date}}",
        "OFFER_EXPIRED": "This offer expired on {{date}}",
        "SUBTITLE": "The following information is an overview of the order",
        "SUBMITTED_BY": "submitted by {{name}}",
        "CREATED_BY": "created by {{name}}",
        "ORDER_INFO_ERROR": "There was a problem loading order info. Try refreshing the page.",
        "UPDATED_TO": "Updated to {{value}}",
        "UPDATED_FROM_TO": "Updated from {{fromValue}} to {{toValue}}",
        "ATTACHMENTS_UPDATED_SUCCESSFULLY": "Attachments were saved",
        "ALL_TAGS_REMOVED": "All tags removed",
        "NO_CONTRACT_START_DATE": "no contract start date",
        "NO_CONTRACT_LENGTH": "no contract length",
        "DATE_BY_USER": "{{date}} by {{user}}",
        "SYSTEM": "system"
      },
      "CUSTOMER_EVENTS": {
        "SENDING": "Sending",
        "PROCESSING": "Processing",
        "DELIVERED": "Delivered",
        "BOUNCED": "Bounced",
        "DROPPED": "Dropped",
        "UNSUBSCRIBED": "Unsubscribed",
        "DEFERRED": "Deferred",
        "SPAM_REPORT": "Spam report",
        "EMAIL_OPENED": "Email opened",
        "EMAIL_CLICKED": "Email clicked",
        "UPDATED_ANSWERS": "Updated answers",
        "UNKNOWN": "Unknown"
      },
      "ORDER_FORM": {
        "CUSTOM_ENTRY_URL": "Custom entry URL",
        "CUSTOM_ENTRY_URL_REGEX_ERROR": "Not in correct format. Should be prefixed with https or http."
      },
      "PRICING": {
        "STARTING_PRICE": "Starting price",
        "STARTING_PRICE_TOOLTIP": "Specifies whether or not the price varies based on usage, list size, or other special considerations",
        "REVENUE_REQUIRED": "Price is required",
        "GREATER_THAN_OR_EQUAL_TO_ZERO": "Must be greater than or equal to zero",
        "MUST_BE_NUM": "Must be a number",
        "PERIOD_REQUIRED": "Period is required",
        "ADD_ROW": "Add row",
        "PRICE": "Price",
        "PERIOD": "Period",
        "PRICING_UPDATED": "Pricing updated",
        "ERROR_UPDATING_PRICING": "There was an error updating the pricing"
      },
      "ERRORS": {
        "ERROR_UPDATING_CONTENTS": "There was an error updating the contents of the order",
        "ERROR_MUST_HAVE_ITEMS": "The order must contain at least one item",
        "ERROR_MUST_HAVE_PRICING": "Order items must have at least one row of pricing",
        "ERROR_ARCHIVING": "There was an error archiving the order",
        "ERROR_CANCELLING": "There was an error cancelling the order",
        "ERROR_IGNORING_ERRORS": "There was an error ignoring the activation errors of the order",
        "ERROR_UPDATING_ORDER_FORM": "There was an error updating the answers of the order form",
        "ERROR_UPDATING_SALESPERSON": "There was an error updating the salesperson of the order",
        "ERROR_FORM_NOT_VALID": "Form is not valid",
        "ERROR_EXPORT_ALL": "There was a problem downloading data. Please try again",
        "ERROR_EXPORT_TOO_MANY_REQUESTS": "Already processing a similar export request",
        "ERROR_ATTACHMENT_GENERIC": "There was an error uploading the attachment",
        "ERROR_DUPLICATE_FILE_ATTEMPT": "This file has already been uploaded",
        "ERROR_MAX_FILE_SIZE_EXCEEDED": "Max file size exceeded",
        "ERROR_MAX_FILES_EXCEEDED": "Max files exceeded",
        "UNABLE_TO_UPDATE_OVERVIEW": "Failed to update opportunity notes",
        "UNABLE_TO_LOAD_DISPLAY_VALUE": "There was a problem loading the display name for this {{value}}.",
        "ERROR_UPDATING_TAGS": "There was an error updating the tags"
      },
      "ACTIVATION_STATUS": {
        "ACTIVATED": "Activated",
        "ALREADY_ACTIVATED": "Already activated",
        "ACTIVATION_ERRORS": "Activation errors",
        "ACTIVATION_WARNINGS": "Activation warnings",
        "ERRORS_IGNORED": "Errors ignored"
      },
      "ACTIONS": "Actions",
      "EDITION_REQUIRED_FOR_PRICE": "Edition required to set price",
      "EXPORT": {
        "SUCCESS_EXPORT_ALL": "Download started",
        "ERROR_TOO_MANY_ROWS": "Please use filters to narrow results, or contact support if this size export is intended.",
        "ERROR_NO_RESULTS": "No results to export.",
        "EXPORT_HEADER": "Generate CSV file for sales orders",
        "EXPORT_DESCRIPTION": "Which data would you like to export?",
        "ALL_ORDER_OPTION_LABEL": "All order data",
        "ALL_ORDER_OPTION_DESCRIPTION": "Outputs all orders matching your filters with additional columns. You'll receive a download notification when your file is ready.",
        "ALL_ORDER_WITH_PRODUCT_DATA_OPTION_LABEL": "All orders with product data",
        "ALL_ORDER_WITH_PRODUCT_DATA_OPTION_DESCRIPTION": "This option will export one row per product included in the order. You'll receive a download notification when your file is ready."
      },
      "DECLINE_REASON": {
        "ERROR": "Something went wrong",
        "TRY_AGAIN": "Try again",
        "MESSAGE": "Decline message",
        "REASONS_TITLE": "Why are you declining this order?",
        "REQUIRED": "Required",
        "MANAGE_REASONS": "Manage reasons"
      },
      "PIPELINE": {
        "PERCENTAGE_OF": "% of",
        "SETTINGS": {
          "PAGE_TITLE": "Manage pipelines",
          "EMPTY_STATE": {
            "TITLE": "Create your first custom pipeline",
            "MESSAGE": "Track and manage your sales opportunities from start to close"
          },
          "MODALS": {
            "DELETE_TITLE": "Delete pipeline?",
            "DELETE_MESSAGE": "Deleting a pipeline with opportunities in it will cause them to no longer show on the pipeline board. Ensure that you have removed all opportunities from this pipeline before deleting it.",
            "UNSAVED_CHANGES_TITLE": "Unsaved changes",
            "UNSAVED_CHANGES_MESSAGE": "Are you sure you want to leave? You will lose any unsaved changes.",
            "UNSAVED_CHANGES_CONFIRM": "Discard changes"
          },
          "BUTTONS": {
            "CREATE": "Create pipeline",
            "SAVE": "Save",
            "CANCEL": "Cancel",
            "DELETE": "Delete",
            "DELETE_PIPELINE": "Delete pipeline",
            "CREATE_NEW": "Create new pipeline",
            "ADD_STAGE": "Add stage"
          },
          "FORMS": {
            "NAME_TITLE": "Pipeline name",
            "NAME_PLACEHOLDER": "New pipeline",
            "STAGES_TITLE": "Pipeline stages",
            "STAGES_SUBTITLE": "Opportunities may shift within the pipeline if you delete a stage or change its probability.",
            "STAGE_NAME": "Stage name",
            "STAGE_PROBABILITY": "Close probability"
          },
          "SNACKBARS": {
            "CREATE_FAILED": "Failed to create a new pipeline, please try again later.",
            "CREATE_SUCCESS": "Successfully created a new pipeline",
            "DELETE_FAILED": "Failed to delete pipeline, please try again later.",
            "DELETE_SUCCESS": "Successfully deleted pipeline",
            "PIPELINE_NAME_UPDATE_FAILED": "Failed to update pipeline name, please try again later.",
            "STAGE_DELETE_FAILED": "Failed to delete stage, please try again later.",
            "STAGE_NAME_UPDATE_FAILED": "Failed to update stage name, please try again later.",
            "STAGE_PROBABILITY_UPDATE_FAILED": "Failed to update stage probability, please try again later.",
            "STAGE_CREATE_FAILED": "Failed to create stages, please try again later.",
            "FORM_INVALID": "Failed to update pipeline, please make sure all fields are correct."
          },
          "DEFAULTS": {
            "NAME": "My new pipeline",
            "STAGE_ONE": "Stage one",
            "STAGE_TWO": "Stage two",
            "STAGE_THREE": "Stage three"
          }
        },
        "EMPTY_PIPELINE_FILTERED_OR_NO_OPPS": "No opportunities to show. You may need to adjust your filters or add an opportunity to an account.",
        "SAVE_FILTER_DIALOG_TITLE": "Choose filter group name",
        "FILTER_NAME_INPUT": "Filter group name",
        "FILTER_OVERWRITTEN_WARNING": "A filter group named {{ filterGroupName }} already exists. Clicking save will overwrite it.",
        "SAVE_FILTER_SUCCESS": "Filter group saved",
        "SAVED_FILTERS": "Saved filters",
        "SAVE_CURRENT_FILTERS": "Save current filters",
        "PIPELINES": "Pipelines",
        "EXPORT_AS_CSV": "Export as CSV",
        "PREPARING_CSV": "Preparing CSV",
        "CSV_EXPORT_ERROR": "There was an issue trying to start the export CSV process, please try again.",
        "PREPARING_DOWNLOAD": "We'll notify you when your file is ready to download.",
        "OK_TO_LEAVE_PAGE": "Navigating away from the page won't interrupt this process.",
        "FILTERS_RETURNED_ZERO_RESULTS_TITLE": "We couldn't find any opportunities that fit your search",
        "FILTERS_RETURNED_ZERO_RESULTS_DESCRIPTION": "You may need to adjust your filters or search terms",
        "PIPELINE_NOT_FOUND": "Pipeline unavailable",
        "REVENUE_FOR_DATE_PERIOD": "Revenue for {{ date }}",
        "MEDDIC": {
          "POINTS": "Points"
        },
        "COLUMN_LABELS": {
          "ACTUAL_CLOSE": "Actual close",
          "ASSIGNED": "Assigned",
          "CALLS": "Calls",
          "CONNECTIONS": "Connections",
          "EXPECTED_CLOSE": "Expected close",
          "LAST_ACTIVITY": "Last activity",
          "LAST_CONNECTED": "Last connected",
          "OPPORTUNITY": "Opportunity",
          "QUALIFICATION": "Qualification",
          "OPPORTUNITY_QUALIFICATION": "Opportunity qualification",
          "POTENTIAL": "Potential",
          "MONTHLY_REVENUE": "Monthly revenue",
          "STAGE": "Pipeline stage",
          "PIPELINE_NAME": "Pipeline name",
          "STATUS": "Status",
          "TOTAL_EFFORTS": "Total efforts",
          "CREATED_DATE": "Created date",
          "TYPE": "Type"
        },
        "ACCOUNT_DELETED": "Account deleted",
        "PIPELINE_STAGE_LABEL": "Pipeline stage",
        "PIPELINE_STAGE_TOOLTIP": "Select a single pipeline to enable pipeline stage selection",
        "EXPECTED_CLOSE_LABEL": "Expected close",
        "ASSIGNED_DATE_LABEL": "Assigned",
        "STATUS_TITLE": "Pipeline status",
        "STATUS_LABEL": "Status",
        "ACTUAL_CLOSE_LABEL": "Actual close",
        "CREATED_DATE_LABEL": "Created",
        "TYPE_LABEL": "Type",
        "POTENTIAL_REVENUE": "Potential revenue",
        "PIPELINE_BOARD": {
          "BOARD": "Board",
          "TABLE": "Table",
          "SORT": "Sort",
          "MANAGE_PIPELINES": "Manage pipelines",
          "SORT_ACTIONS": {
            "EXPECTED_CLOSE_DATE": "Expected close date",
            "ACTUAL_CLOSE_DATE": "Actual close date",
            "POTENTIAL_REVENUE": "Potential revenue",
            "LAST_CONNECTED_DATE": "Last connected date",
            "LAST_SALES_ACTIVITY": "Last sales activity",
            "CREATED_DATE": "Created date",
            "ASSIGNED_DATE": "Assigned date",
            "NAME": "Opportunity name",
            "QUALIFICATION": "Qualification"
          }
        },
        "TABLE": {
          "EXPORT_CSV": {
            "TITLE": "Select files to export",
            "PIPELINE": "Pipeline",
            "OPPORTUNITY_HISTORY": "Opportunity history"
          },
          "ERRORS": {
            "FETCH_OPPORTUNITIES_ERROR_TITLE": "An error occurred when fetching your opportunities",
            "FETCH_OPPORTUNITIES_ERROR_DESCRIPTION": "Refresh your page or adjust your search to try again",
            "NAVIGATE_TO_PAGE": "Unable to open the page. Reload the page and try again."
          }
        }
      },
      "COMMON": {
        "NOTES": "Notes",
        "LOST": "Lost",
        "WON": "Won",
        "TAG": "Tag",
        "SELECT_PACKAGES": "Select packages",
        "SELECT_PRODUCTS": "Select products",
        "SELECT_ACCOUNT": "Select account",
        "SELECT_TYPE": "Select type",
        "PACKAGES_LABEL": "Packages",
        "PRODUCTS_LABEL": "Products",
        "SALESPEOPLE_LABEL": "Salespeople",
        "SALES_TEAM_LABEL": "Sales team",
        "WARNING": "Warning",
        "ASSIGNEE": "Assignee",
        "EMAILS": "Emails",
        "MEETINGS": "Meetings",
        "NOT_APPLICABLE_LABEL": "N/A",
        "NONE_LABEL": "None",
        "MARKET_LABEL": "Market",
        "DELETED": "Deleted",
        "ACTION_LABELS": {
          "ACTIVE": "active",
          "ADD": "Add",
          "ADD_NEW": "Add new",
          "ADD_ATTACHMENT": "Add attachment",
          "APPLY": "Apply",
          "BACK": "Back",
          "BOOKING_LINK": "Booking link",
          "CALL": "Call",
          "CANCEL": "Cancel",
          "CLICK_TO_REFRESH": "Click to refresh",
          "CLICK_TO_RETRY": "Click to retry",
          "CLOSE": "Close",
          "COMPOSE_MESSAGE": "Compose message",
          "ERROR_SENDING_MESSAGE": "An error occurred while sending the message",
          "MESSAGE_SENT_SUCCESSFULLY": "Message sent successfully",
          "CONTACT_EMAILS": "Send contact email",
          "CONTINUE": "Continue",
          "COPY": "Copy",
          "COPY_LINK": "Copy link",
          "CREATE": "Create",
          "DELETE": "Delete",
          "EDIT": "Edit",
          "EMAIL": "Email",
          "JOIN": "Join",
          "LEARN_MORE": "Learn more",
          "LOAD_MORE": "Load more",
          "MORE_ACTIONS": "More actions",
          "NEXT": "Next",
          "PAUSE": "Pause",
          "PREVIEW": "Preview",
          "REFRESH": "Refresh",
          "RESUME": "Resume",
          "RETRY": "Retry",
          "SAVE": "Save",
          "SELECT_ALL": "Select all",
          "SELECT_DATE": "Select date",
          "SEND": "Send",
          "SUBMIT": "Submit",
          "TRY_AGAIN": "Try again",
          "UPDATE": "Update",
          "UNDO": "Undo",
          "UNDO_ARCHIVE": "Unarchive",
          "UNSAVED_CHANGE": "You have unsaved changes",
          "VIEW": "View",
          "VIEW_ALL": "View all",
          "VIEW_MORE": "View more",
          "VIEW_LESS": "View less",
          "PRINT": "Print",
          "ACTIONS": "Actions",
          "OK": "OK",
          "EXPORT": "Export",
          "START": "Start",
          "SHOW_MORE": "Show more"
        },
        "BILLING_FREQUENCIES": {
          "ONE_TIME": "One time",
          "MONTHLY": "Monthly",
          "YEARLY": "Yearly"
        },
        "LOADING": "Loading...",
        "NAME": "Name",
        "ACCOUNT_NAME": "Account name",
        "PROBABILITY": "Probability",
        "DATES": {
          "FROM_LABEL": "From",
          "TO_LABEL": "To",
          "NEVER": "Never",
          "CUSTOM": "Custom",
          "DATE_RANGE": "Date range",
          "CREATED_ON": "Created on {{date}}",
          "TODAY": "Today",
          "INVALID_DATE_RANGE": "Invalid date range"
        }
      },
      "FILTER_BY_SALESPEOPLE": "Filter by salespeople",
      "FILTER_BY_SALES_TEAM": "Filter by sales team",
      "FILTER_BY_PIPELINES": "Filter by pipelines",
      "TASK_STATUS": {
        "OPEN": "Open",
        "IN_PROGRESS": "In progress",
        "WAITING_ON_CUSTOMER": "Waiting on customer",
        "COMPLETED": "Completed"
      },
      "SELECT_TAG": "Select tag",
      "PROJECTED_MONTHLY_REVENUE": "Monthly revenue",
      "FORMS": {
        "CHOOSE_ACCOUNT": "Choose an account",
        "CHOOSE_LINE_ITEMS": "Choose products and packages",
        "ADDITIONAL_INFO": "Additional info",
        "INVALID_FORM": "Form is invalid",
        "INVALID_CONTACT_DURATION": "Contract length is invalid"
      }
    },
    "SALES_OPPORTUNITIES": {
      "ADD_PACKAGES": "Add packages",
      "OPPORTUNITY_VALUE": "Opportunity value",
      "ACCOUNT_INFO": "Account info",
      "OPPORTUNITY_INFO": "Opportunity info",
      "OPPORTUNITIES_LABEL": "Opportunities",
      "SUCCESSFUL_CREATION": "Successfully created opportunity",
      "OPPORTUNITY_CREATE": "Create sales opportunity",
      "OPPORTUNITY_NAME": "Opportunity name",
      "EMPTY_OPPORTUNITIES_DESCRIPTION": "There are no opportunities.",
      "POTENTIAL_REVENUE": "Potential revenue",
      "PROJECTED_MONTHLY_REVENUE": "Monthly revenue",
      "MONTHLY_REVENUE": "Monthly revenue",
      "PROBABILITY_TO_CLOSE": "{{percentage}}% probability.",
      "NO_ASSIGNEE_TEXT": "Salesperson deleted",
      "NO_PACKAGES_TIP": "Create sales opportunities using the packages in your store. Come back to begin tracking your opportunities as packages become available.",
      "PROBABILITY_OF_CLOSE": "Probability of close",
      "PIPELINE_STAGE": "Pipeline stage",
      "EXPECTED_CLOSE_PLACEHOLDER": "Expected close date",
      "SELECT_PACKAGES": "Select packages *",
      "SELECT_A_PACKAGE_ERROR": "At least one package must be selected",
      "SELECT_QUANTITIES": "Select package quantities",
      "NO_NOTES_FOR_OPPORTUNITY": "There are no notes for this opportunity.",
      "NO_PACKAGES_FOR_OPPORTUNITY": "There are no packages for this opportunity.",
      "REMOVE_PACKAGE_CONFIRMATION": "Are you sure you want to remove {{ packageName }}?",
      "PACKAGE_WILL_BE_REMOVED": "The package will be removed from this opportunity.",
      "REVENUE_TOOLTIP": "This adds up all one-time fees and calculates all recurring revenue for the contract length. To change this value, edit the revenue for the packages below.",
      "QUANTITIES": "Quantities",
      "QUANTITY": "Quantity",
      "DETAILS": "Details",
      "ACTIVITY": "Activity",
      "ASSIGNED_TO": "Assigned to {{ person }}",
      "ASSIGN_TO": "Assign to",
      "OVERVIEW": "Overview",
      "BUSINESS": "Business:",
      "REOPEN": "Reopen",
      "CONTRACT_DURATION_REVENUE": "{{ durationAndPeriod }} revenue",
      "DEFAULT_DURATION_REVENUE": "Per year",
      "ADD_OPPORTUNITY_TAGS": "Add opportunity tags",
      "CLOSED_WON": "Closed won",
      "CLOSED_LOST": "Closed lost",
      "WON": "Won",
      "LOST": "Lost",
      "OPEN": "Open",
      "WON_FILTER": "closed-won",
      "LOST_FILTER": "closed-lost",
      "OPEN_FILTER": "open",
      "STAGE": "Stage",
      "ACTUAL_CLOSE_DATE_UPDATED": "Actual close date updated",
      "OPPS_NOT_ON_PIPELINE": "Migrate opportunities",
      "HIDE_ORPHANED_OPPORTUNITIES": "Show pipeline",
      "SUCCESSFULLY_ASSIGNED_OPPORTUNITIES": "Successfully assigned all selected opportunities",
      "FAILED_TO_ASSIGNED_OPPORTUNITIES": "Failed to assign one or more opportunities, please try again",
      "OPPORTUNITY_ITEMS_REQUIRED": "You must add at least one item to the opportunity contents",
      "ACCOUNT_REQUIRED": "You must select an account for the opportunity",
      "OPPORTUNITY_CONTENTS": "Items",
      "PIPELINE": "Pipeline",
      "CLOSE": {
        "CLOSE_OPPORTUNITY": "Close opportunity",
        "TITLE": "Close opportunity",
        "CLOSE_STATE": "Close state",
        "MESSAGE": "This will close the opportunity with the current revenue and packages. The opportunity will no longer be editable.",
        "OPPORTUNITY_CLOSE": "Close opportunity",
        "SELECT_STATE": "Select state",
        "CLOSED_LOST": {
          "REASON": "Reason",
          "SELECT_REASON": "Select reason",
          "PRICE": "Price",
          "NO_BUDGET": "No budget",
          "LOST_TO_COMPETITOR": "Lost to competitor",
          "NOT_READY": "Not ready",
          "OTHER": "Other"
        }
      },
      "OPPORTUNITY_TYPE": {
        "NOT_SPECIFIED": "Not specified",
        "NEW_BUSINESS": "New business",
        "EXISTING_BUSINESS": "Existing business",
        "PLACEHOLDER": "Type",
        "SUCCESS": "Successfully changed opportunity type.",
        "ERROR": "Unable to change opportunity type."
      }
    }
  },
  "MEDDIC": {
    "POINTS": "Points",
    "PROBLEM_SAVING_SCORES": "There was a problem storing your MEDDIC scores",
    "PROBLEM_SAVING_NOTES": "There was a problem storing your MEDDIC notes",
    "PROBLEM_LOADING_NOTES": "There was a problem loading the MEDDIC notes",
    "NOTES_SAVED": "Your notes were saved",
    "SCORE_NAMES": {
      "METRIC": "Metrics",
      "ECONOMIC_BUYER": "Economic buyer",
      "DECISION_CRITERIA": "Decision criteria",
      "DECISION_PROCESS": "Decision process",
      "IDENTIFY_PAIN": "Identify pain",
      "CHAMPION": "Champion",
      "COMPETITION": "Competition",
      "PAPER_PROCESS": "Paper process"
    },
    "SCORE_DESCRIPTIONS": {
      "METRIC": "Metrics are the criteria your prospect uses to determine the success of this solution. This helps you prove return on investment (ROI) to your prospect.",
      "ECONOMIC_BUYER": "The economic buyer is the person that can ultimately approve the purchase of this solution. If possible, try to establish a relationship directly with this person.",
      "DECISION_CRITERIA": "Decision criteria are factors that impact whether your prospect purchases your solution. Common examples include budget constraints, potential return on investment (ROI), learning curve, and integration options.",
      "DECISION_PROCESS": "The decision process covers how your prospect decides to purchase new solutions. Examples include who makes decisions, what formalities are involved, and general turn-around time. This is useful in ensuring your deal won't fall apart or end up in limbo.",
      "IDENTIFY_PAIN": "When you identify pain, you know exactly which problems your solution solves for your prospect. Try to be as specific as possible to best pitch your solution.",
      "CHAMPION": "A champion is a well-respected advocate within the prospect's company. They are invested in your solution and will push for the company to purchase."
    },
    "SCORE_OPTIONS": {
      "PLACEHOLDER": "Select an option",
      "METRIC": {
        "SCORE_0": "I have no idea",
        "SCORE_1": "I know some of the metrics, but details are still fuzzy",
        "SCORE_2": "I know exactly how the company will validate this solution"
      },
      "ECONOMIC_BUYER": {
        "SCORE_0": "I'm not sure",
        "SCORE_1": "I have the names of some people that can potentially purchase",
        "SCORE_2": "I know who approves purchases"
      },
      "DECISION_CRITERIA": {
        "SCORE_0": "I don't know",
        "SCORE_1": "I know some of the criteria, but not all",
        "SCORE_2": "I know exactly how they're evaluating my solution"
      },
      "DECISION_PROCESS": {
        "SCORE_0": "I'm not sure",
        "SCORE_1": "I know some of the process, but not the whole thing",
        "SCORE_2": "I know every step involved"
      },
      "IDENTIFY_PAIN": {
        "SCORE_0": "I haven't learned that yet",
        "SCORE_1": "I understand some of it, but I'm not clear on the specifics",
        "SCORE_2": "I fully understand the pain my prospect is trying to alleviate"
      },
      "CHAMPION": {
        "SCORE_0": "There's no one that I know of",
        "SCORE_1": "There's a few people who might, but no one concrete",
        "SCORE_2": "I know my champion"
      },
      "COMPETITION": {
        "SCORE_0": "Unaware of competitors",
        "SCORE_1": "Know competitors, lack comparison",
        "SCORE_2": "Understand competitors and differentiation"
      },
      "PAPER_PROCESS": {
        "SCORE_0": "No defined paper process",
        "SCORE_1": "Some steps identified, but not fully defined",
        "SCORE_2": "Clearly defined paper process from decision to signature"
      }
    },
    "POINT_VAL_0": "0 Points",
    "POINT_VAL_1": "1 Point",
    "POINT_VAL_2": "2 Points",
    "FAILED_TO_LOAD": "There was a problem loading the MEDDIC scores for this opportunity",
    "REASON_FOR_SCORE": "Reason for score"
  },
  "SALES_EXPECTED_CLOSE": {
    "UNABLE_TO_UPDATE_EXPECTED_CLOSE": "Failed to update expected close date",
    "EXPECTED_CLOSE_UPDATED": "Expected close date updated",
    "PLACEHOLDER": "Select a date"
  },
  "SALES_CONTRACT_DURATION": {
    "TITLE": "Expected contract length",
    "DETAILS_SECTION_TITLE": "Contract length",
    "ENTER_DURATION": "enter length",
    "PERIOD": "Period",
    "DURATION": "Length",
    "HINT": "Use this field for reference only. Orders and product expiration dates will not be impacted by this timeframe.",
    "DURATION_UPDATED": "Contract duration updated",
    "ERRORS": {
      "INVALID_FORMAT": "Must be a valid number higher than 0",
      "UNABLE_TO_UPDATE_DURATION": "Failed to update contract duration"
    },
    "DURATIONS": {
      "DAY": "day(s)",
      "WEEK": "week(s)",
      "MONTH": "month(s)",
      "YEAR": "year(s)",
      "DAY_SINGULAR": "day",
      "WEEK_SINGULAR": "week",
      "MONTH_SINGULAR": "month",
      "YEAR_SINGULAR": "year"
    },
    "TOOLTIP": {
      "CLEAR": "Remove contract length",
      "EDIT": "Edit contract length"
    }
  },
  "SALES_ACTIVITY": {
    "ADD_NOTES": "Add notes"
  }
}
